import Router from '../router/index'
import axios from 'axios'
import store from '../store'

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 设置请求格式
    config.headers.common['Content-Type'] = 'application/json'
    // 设置语言
    // let language = localStorage.getItem('lang')
    // language = language || 'en_US'
    // config.headers.common['X-Req-Language'] = language

    let langcode = localStorage.getItem('lang')
    langcode = langcode || window.config.VUE_APP_DEFAULT_LANG

    let _lang = window.config.VUE_APP_LANG_LIST.split(';').map(x => {
      return {
        name: x.split(':')[0],
        langcode: x.split(':')[1],
        xReqLanguage: x.split(':')[2]
      }
    }).find(x => x.langcode === langcode)
    config.headers.common['X-Req-Language'] = _lang.xReqLanguage

    // 设置token
    let token = localStorage.getItem('token')
    // 每次请求加上token（登录除外）
    if (token) {
      config.headers.common['X-USER-TOKEN'] = token
    }
    config.timeout = 15000
    return config
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // 处理超时
    if (error.message.indexOf('timeout') === 0) {
      alert('timeout')
      return Promise.reject(error.response)
    }
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录（处理别处登录时本地token失效）
        case 401:
          // console.log(error.response)
          localStorage.clear()
          store.commit('cleanToken')
          Router.push({path: '/'})
          break
        default:
          return Promise.reject(error.response)
      }
      return Promise.reject(error.response)
    }
  }
)

export default{
  axios
}



// WEBPACK FOOTER //
// ./src/axios/axios-init.js